export const expertsData = [
  {
    id: 4,
    name: 'آقای عسگری',
    job_title: 'مدير Retail (موتور برق و ديزل ژنراتور)',
    category: 'موتور برق و دیزل ژنراتور',
    internal_number: '102',
    phone: '09391004066',
    whatsapp_link: 'https://api.whatsapp.com/send?phone=989391004066',
    profile_photo: '/images/person-6.jpg',
  },
  {
    id: 1,
    name: 'خانم ایزانلو',
    job_title: 'كارشناس فروش (تجهيزات پسيو و كابل شبكه) ',
    category: 'تجهيزات پسيو و كابل شبكه',
    phone: '09393455474',
    internal_number: '111',
    whatsapp_link: 'https://api.whatsapp.com/send?phone=989393455474',
    profile_photo: '/images/person-1.jpg',
  },

  {
    id: 2,
    name: 'خانم گودرزی',
    category: 'انواع مودم و روتر',
    job_title: 'کارشناس فروش (انواع مودم و روتر) ',
    internal_number: '112',
    phone: '09361003058',
    whatsapp_link: 'https://api.whatsapp.com/send?phone=989361003058',
    profile_photo: `/images/person-8.png`,
  },
  {
    id: 3,
    name: 'خانم جاوید',
    internal_number: '103',
    category: 'تجهيزات پسيو و كابل شبكه',
    job_title: 'كارشناس فروش (تجهيزات پسيو و كابل شبكه) ',
    whatsapp_link: 'https://api.whatsapp.com/send?phone=989361003052',
    profile_photo: `/images/women.jpg`,
  },
];
